import Cookies from 'js-cookie';
import { USER_ACCESS_COOKIE, USER_TYPE } from '../constants/constants';

export const getLastCampaingBonusJourney = () => {
  const { bonusJourney, userType } = Cookies.getJSON(USER_ACCESS_COOKIE);

  if (userType === USER_TYPE.consultancy) return null

  return bonusJourney.lastCampaign && bonusJourney.lastCampaign;
};




